// Modules
import React, { useContext } from "react";
import PropTypes from "prop-types";
import Skeleton from "@material-ui/lab/Skeleton";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
import Table from "../utils/Table";
import Divider from "../utils/Divider";

// Assets
import "./co-property.scss";

const CoProperty = (props) => {
	const { data, loader } = props;
	let {
		photo_copro,
		photo_facade,
		annee_construction,
		ascenseur,
		balcon,
		cave,
		chauffage,
		double_vitrage,
		lots_copro,
		details_bien,
		terrasse,
		etage_bien_bati,
		stationnement,
	} = data;
	ascenseur = ascenseur === true ? "Oui" : "Non";
	balcon = balcon === true ? "Oui" : "Non";
	cave = cave === true ? "Oui" : "Non";
	terrasse = terrasse === null ? "Non" : "Oui";
	const { isMobile, isTablet } = useContext(ApiContext);

	const coproRows = [
		{
			name: "Copropriété",
			value: `${lots_copro} lots`,
		},
		{
			name: "Étage",
			value: etage_bien_bati,
		},
		{
			name: "Année de construction",
			value: annee_construction,
		},
		{
			name: "Double vitrage",
			value: double_vitrage,
		},
		{
			name: "Chauffage",
			value: chauffage,
		},
		{
			name: "Détails du bien",
			value: details_bien,
		},
		{
			name: "Balcon",
			value: balcon,
		},
		{
			name: "Terrasse",
			value: terrasse,
		},
		{
			name: "Ascenseur",
			value: ascenseur,
		},
		{
			name: "Cave",
			value: cave,
		},
		{
			name: "Stationnement",
			value: stationnement,
		},
	];

	return (
		<React.Fragment>
			<Divider text="Copropriété" loader={loader} />
			<div className={`co-property-container ${isMobile === true || isTablet === true ? "mobile" : ""}`}>
				<div className="left-container">
					{loader
						? (
							<>
								<Skeleton variant="rect" width="40vh" height="50vh" />
								<Skeleton variant="rect" width="40vh" height="50vh" />
							</>
						)
						: (
							<React.Fragment>
								{photo_facade
									? (
										<div
											style={{ backgroundImage: `url(${photo_facade})` }}
											title="Façade de l'immeuble"
											className="photo"
										/>
									) : null}
								{photo_copro
									? (
										<div
											style={{ backgroundImage: `url(${photo_copro})` }}
											title="Copriété"
											className="photo"
										/>
									) : null}
							</React.Fragment>
						)}
				</div>

				<div className="right-container">
					<div className="table-container">
						<Table
							header="Informations de copropriété"
							colNb={2}
							rows={coproRows}
							loader={loader}
							aspect="empty"
							split={isMobile === true || isTablet === true ? false : true}
						/>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

CoProperty.propTypes = {
	data: PropTypes.object,
	loader: PropTypes.bool.isRequired,
};

CoProperty.defaultProps = {
	data: {},
};

export default CoProperty;